import { AppConfig } from '../app.config';
import { NetworkRequestOptions } from '../interfaces/request';
import { RxRequestService } from './rx-request.service';


export class DbtModelService {
  static deps = [
    AppConfig,
    RxRequestService
  ];

  constructor(
    private _appConfig: AppConfig,
    private _rxRequestService: RxRequestService
  ) {
  }

  private modelsUrl: string = this._appConfig.getDbtURL();

  getModels() {
    const options: NetworkRequestOptions = {
      uiOptions: {
        showSuccessMsg: false,
        showLoading: false
      }
    };

    return this._rxRequestService.get(this.modelsUrl, options);
  }

  pauseAllModels(projectId: number) {
    const requestUrl = `${this.modelsUrl}/project/${projectId}/pause`;

    const options: NetworkRequestOptions = {
      uiOptions: {
        showLoading: false,
        showSuccessMsg: false,
        showErrorMsg: true
      }
    };

    return this._rxRequestService.put(requestUrl, options);
  }

  resumeAllModels(projectId: number) {
    const requestUrl = `${this.modelsUrl}/project/${projectId}/resume`;

    const options: NetworkRequestOptions = {
      uiOptions: {
        showLoading: false,
        showSuccessMsg: false,
        showErrorMsg: true
      }
    };

    return this._rxRequestService.put(requestUrl, options);
  }
}
